<template>
  <extensions-permission-guard :situation-id="situationId">
    <product-form-layout
      :product-images.sync="productImages"
      :product="product"
    />
    <v-btn
      class="px-10 my-2 text-body-2 float-right"
      color="primary darken-1"
      min-height="50px"
      min-width="100px"
      tile
      dark
      depressed
      @click="createProduct"
    >
      保存
    </v-btn>
  </extensions-permission-guard>
</template>

<script>
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { PRODUCTS_SITUATION_ID } from '@/mixins/site_permission_utils'
import {
  upload as uploadImage,
  _delete as deleteImage
} from './api/productImages'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import ProductFormLayout from '@/components/commons/products/ProductFormLayout'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    ProductFormLayout,
    ExtensionsPermissionGuard
  },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: '新規商品作成',
      situationId: PRODUCTS_SITUATION_ID,
      taxIncludedSelectItems: [
        { text: '税込', value: true },
        { text: '税抜', value: false }
      ],
      product: {
        name: '',
        price: null,
        description: '',
        isTaxIncluded: true,
        published: false,
        identificationCode: null,
        productLinksAttributes: [
          {
            productLinkStyleId: null,
            linkText: '',
            price: null,
            isTaxIncluded: null,
            url: '',
            priority: 0
          }
        ]
      },
      productImages: []
    }
  },
  methods: {
    createProduct () {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .post('/api/products', { product: this.product })
        .then(async ({ data }) => {
          const productId = deserialize(data).data.id
          await this.uploadImageService(productId)

          const payload = {
            status: 200,
            message: '保存に成功しました。'
          }
          await this.$store.dispatch(
            'SystemMessageStore/createMessage',
            payload
          )
          this.$router.push('/admin/products')
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    },
    async uploadImageService (productId) {
      return Promise.all(
        this.productImages.map((image, index) => {
          if (image.deleted) return deleteImage(productId)
          return uploadImage(productId, image.file, image.url, image.altAttribute, index)
        })
      )
    }
  }
}
</script>
